module.exports = {
    //Common Button
    "BTN_SEARCH": "Search",
    "BTN_CLEAR": "Clear",
    "BTN_ADD": "Add",
    "BTN_DOWNLOAD": "Download",

    "USR_ACTIVE": "Active",
    "USR_INACTIVE": "InActive",

    //usr-common
    "USR_LOAD_ERROR_DESCRIPTION": "Please try reload this page again.",
    "USR_LOAD_CAMPUS_ERROR": "Cannot load campus options.",
    "USR_LOAD_FACULTY_ERROR": "Cannot load faculty options.",
    "USR_LOAD_EDULEVEL_LIST_ERROR": "Cannot load edulevel options.",

    //common
    "COMMON__COLLAPSE_DATA_NOT_FOUND": "Detail data not found",
    "COMMON__YES": "Yes",
    "COMMON__NO": "No",
    "COMMON__SHOW": "Show",
    "COMMON__DO_NOT_SHOW": "Don't Show",
    "COMMON__ACCEPT": "Accept",
    "COMMON__DO_NOT_ACCEPT": "Don't Accept",
    "COMMON__RECORD_STATUS": "Record status",
    "COMMON__ADD_DETAILS": "Add Details",
    "COMMON__RECORD_STATUS_ACTIVE": "Active",
    "COMMON__RECORD_STATUS_INACTIVE": "Inactive",
    "COMMON__PLEASE_ADD_DETAILS": "Please add details",
    "COMMON__IMPORT_LIST": "Import รายชื่อ",
    "COMMON__CREATED_DATE": "Created Date",
    "COMMON__CREATED_BY": "Create By",
    "COMMON__UPDATED_DT": "Update Date",
    "COMMON__EDIT_DATE": "Edited Date",
    "COMMON__UPDATED_BY": "Update By",
    "COMMON__EDITED_BY": "Edited By",
    "COMMON__CF_DELETE_DATA": "Please confirm you want to delete data",
    "COMMON__OR_NOT": "?",
    "COMMON__DELETE_DATA": "Delete Data",
    "COMMON__ALL_RESULTS": "All search results",
    "COMMON__ITEMS": "item(s)",
    "COMMON__UPDATED_BY_": "Update By",
    "COMMON__CANNOT_BE_PROCRESS": "ขออภัยไม่สามารถดำเนินการได้ในขณะนี้",
    "COMMON__TITLE_ADD_DATA": "Add Data",
    "COMMON__CF_ADD_DATA": "Please confirm you want to add data",
    "COMMON__TITLE_EDIT_DATA": "ยืนยันการแก้ไข",
    "COMMON__CF_EDIT_DATA": "กรุณายืนยัน ต้องการแก้ไขข้อมูล",
    "COMMON__IMPORT_DATA": "Import Data",
    "COMMON__CREATE_IMPORT_DT": "วันที่บันทึกข้อมูล",
    "COMMON__ACADEMIC_YEAR": "Academic Year",
    "COMMON__SEMESTER": "Semester",
    "COMMON__IMPORT_DATA_SUCCESS": "Imported data successfully",
    "COMMON__IMPORT_DATA_UNSUCCESS": "Imported data Failed",
    "COMMON__CF_IMPORT_DATA": "กรุณายืนยัน ต้องการนำเข้าข้อมูล",
    "COMMON__SEARCHING": "Searching..",
    "COMMON__STUDENT_CODE": "Student Code",
    "COMMON__CAMPUS": "Campus",
    "COMMON__FACULTY": "Faculty",
    "COMMON__DEPARTMENT": "Department",
    "COMMON__MAJOR": "Major",
    "COMMON__STUDENT_TYPE": "Student Type",
    "COMMON__START_YEAR": "ภาคการศึกษา / ปีการศึกษาที่เข้า",
    "COMMON__SEARCH_STD": "Search Student(s)",
    "COMMON__SELECT_ALL": "Select All",
    "COMMON__EDUCATION_LEVEL": "Education level",
    "COMMON__IMPORT_SUCCESS_TAB": "Import Success",
    "COMMON__IMPORT_UNSUCCESS_TAB": "Import Unsuccess",
    "COMMON__CREATE_SAVE_DT": "วันที่บันทึกข้อมูล",
    "COMMON__CREATE_SAVE_BY": "ผู้บันทึกข้อมูล",
    "COMMON__IMPORT_CHANNEL": "ช่องทางการนำเข้า",
    "COMMON__GOBACK_STEP": "Go Back",
    "COMMON__START_DATE": 'Start Date',
    "COMMON__END_DATE": 'End Date',
    "COMMON__CLICK_FOR_SELECT": "Please Click to Select",
    "COMMON__CONFIRM_DELETE_DATA": "Are you confirm to delete data??",
    "COMMON__AMOUNT": "Amount",
    "COMMON__CAMPUS_CODE": "Campus code",
    "COMMON__CONFIRM_DELETE": "Please confirm to delete data",
    "COMMON__BANK": "Bank",
    "COMMON__UPLOADING": "Uploading",
    "COMMON__SPECIAL_SUBJECT": "Special subject",
    "COMMON__DETAILS": "Details",
    "COMMON__DOWNLOAD_TEMPLATE": "Download Template",
    "COMMON__EX_TEMPLATE": "Template",
    "COMMON__BACK_TO_SEARCH_PAGE": "Back to Search Page",
    "COMMON__IMPORT_BY_EXCEL": "Confirm Import Data",
    "COMMON__DELETE_SUCCESS": "Deleted Success",
    "COMMON__CANT_BE_PRCSS_DUP": "Cannot be process",
    "COMMON__STUDENT_LIST_NAME": "Student List Name",
    "COMMON__NUMBER_OF_STUDENT(S)": "Number of Student(s)",
    "COMMON__CAMPUS_LOCATION": "Campus",
    "COMMON__IMPORT_BY": "Import By",
    "COMMON__IMPORT_DATE": "Import Date",
    "COMMON__VALIDATING": "Validating Information just a moment",
    "COMMON__PLEASE_CONFIRM": "Please confirm",
    "COMMON__DELETE_SUCCESSFUL": "Delete successfully",
    "COMMON__UPLOAD_FILES": "Upload files",
    "COMMON__ADD_SUCCESSFUL": "Add successfully",
    "COMMON__EDIT_SUCCESSFUL": "Edit successfully",
    "COMMON__RETURN_TO_SEARCH_PAGE": "Returning to search page",

    //page masterfee
    "MASTER_FEE__FEE_TITLE": "Fee management",
    "MASTER_FEE__FEE_DETAIL_TITLE": "Fee details",
    "MASTER_FEE__FEE_RATE_TITLE": "Fee rate (Pattern)",
    "MASTER_FEE__FEE_RATE_DETAIL_TITLE": "Fee rate detail",
    "MASTER_FEE__FEE_NAME_TH": "Fee name (Thai)",
    "MASTER_FEE__FEE_NAME_EN": "Fee name (English)",
    "MASTER_FEE__FEE_NAME_PATTERN_TH": "Fee name Pattern (Thai)",
    "MASTER_FEE__FEE_NAME_PATTERN_EN": "Fee name Pattern (English)",
    "MASTER_FEE__FEE_TYPE": "Fee Type",
    "MASTER_FEE__FEE_DESCRIPTION": "Description",
    "MASTER_FEE__NAME_AND_FEE_CODE": "Name and Fee code", //unsure
    "MASTER_FEE__PARENT_CODE": "Parent code", //unsure
    "MASTER_FEE__STATUS": "Status",
    "MASTER_FEE__FEE_CODE": "Fee code", //unsure
    "MASTER_FEE__DELETE_FEE_MANA_SUC": "Deleted Fee management sucessfully",
    "MASTER_FEE__FEE_DETAIL_STATUS": "Status",
    "MASTER_FEE__FEE_DETAIL_CREATE_BY": "Create by",
    "MASTER_FEE__FEE_DETAIL_CREATE_DATE": "Create date",
    "MASTER_FEE__FEE_DETAIL_EDIT_DATE": "Edited date",
    "MASTER_FEE__FEE_DETAIL_EDIT_BY": "Edited by",
    "MASTER_FEE__FEE_DETAIL_ADD_FEE_SUC": "Add Fee management sucessfully",

    //page normalFee
    "NORMAL_FEE__TITLE": "Normal Fee", //unsure
    "NORMAL_FEE__DETAIL_TITLE": "Normal Fee Detail", //unsure
    "NORMAL_FEE__FDC_CONFIRM_DELETE": "Are you sure to delete Fee data?", //unsure
    "NORMAL_FEE__FDC_DELETE_SUC": "Deleted Fee data successfully",
    "NORMAL_FEE__FDC_FORMAT_CODE": "Format Code", //unsure
    "NORMAL_FEE__NFD_ADD_FEE_DATA_SUC": "Added Fee data successfully",
    "NORMAL_FEE__NFD_SET_DEBT_BY_FEE": "Set a general debt by fee", //unsure
    "NORMAL_FEE__NFD_CATEGORY_HEADING": "Category heading", //unsure
    "NORMAL_FEE__NFD_NOT_CATEGORY_HEADING": "Not a category heading",
    "NORMAL_FEE__SET_AOLLOCATION": "Set allocation", //unsure
    "NORMAL_FEE__AGENCY_CODE": "Agency code", //unsure
    "NORMAL_FEE__FEE_RATE_TYPE": "Fee rate type", //unsure
    "NORMAL_FEE__USAGE_TYPE": "Usage type", //unsure //implementation type
    "NORMAL_FEE__ADJUSTMENT_FORMAT": "Adjustment format", //unsure
    "NORMAL_FEE__DONT_SHOW_MAX_FINE": "Don't show a maximum fine", //unsure
    "NORMAL_FEE__MAX_FINE": "Maximum fine",
    "NORMAL_FEE__SET_FINE_START_DATE": "Determine the fine's start date",
    "NORMAL_FEE__SCHEDULE": "schedule",

    //page ManageBankAccount
    "MBA__TITLE": "Manage bank account",//unsure
    "MBA__BANK_ACCOUNT_NAME": "Bank account name",
    "MBA__ACCOUNT_NAME": "Account name",
    "MBA__DELETE_BANK_ACC_NO_SUC": "Deleted bank account number data successfully", //unsure
    "MBAD__ADD_BANK_ACC_NO_SUC": "Added bank account number data successfully",
    "MBAD__TITLE": "Manage bank account details", //unsure
    "MBAD__BILLER_ID": "Biller ID",
    "MBAD__BANK_ACCOUNT_TYPE": "Bank account type ",

    //page ManageInstallment
    "MSI__TITLE": "Manage split installment", //unsure
    "MSI__DELETED_SUC": "Deleted split installment successfully", //unsure
    "MSI__NAME_TH": "Name (Thai)",
    "MSI__NAME_ENG": "Name (English)",
    "MSI__INSTALLMENT_AMOUNT": "Amount of installment",
    "MSI__INSTALLMENT": "งวด",
    "MSI__ADD_SUCCESS": "เพิ่มข้อมูลการแบ่งงวดชำระเงินสำเร็จ",

    //page RequestWaiver
    "RW__HEADER_TITLE": "Request a waiver",
    "RW__SUCCESS": "Allowed",
    "RW__FAILED": "Not allow",
    "RW__REASON": "Reason",
    "RW__ALLOW": "Allow",
    "RW__CREATE_DATE": "Created date",
    "RW__UPDATE_DATE": "Updated date",
    "RW__CREATER": "Created by",
    "RW__UPDATER": "Updated by",
    "RW__STATUS_CASE_3": "Students have been imported data for this semester.",
    "RW__STATUS_CASE_4": "Students have a overdue payment more than 2 semesters.",
    "RW__LENIENT_ACADEMIC_YEAR": "lenient academic year",
    "RW__LENIENT_SEMESTER": "semester lenient",
    "RW__LENIENT_STUDENT": "List of students who have been waived",
    "RW__IMPORT_LENIENT_STUDENT": "Import waiver data",
    "RW__CHOOSE_YEAR_SEMESTER": "Please select the semester and academic year for the waiver",
    "RW__STUDENT_NOT_FOUND_DT": "*นิสิตที่สามารถผ่อนผันได้ ต้องมีสถานภาพนิสิตเป็น นิสิตปัจจุบัน, นิสิตใหม่, ลาพักการศึกษา และ ถูกลงโทษทางวินัยเท่านั้น",
    "RW__IMPORT": "Import waiver",
    "RW__IMPORT_RW_GROUP": "Requesting a waiver for groups/individuals",

    //form validation
    "VALIDATION__REQUIRED": "This field is required.",
    "VALIDATION__REQUIRED_IF": "This field is required.",
    "VALIDATION__REQUIRED_IF_VALUE": "This field is required.",
    "VALIDATION__LENGTH_GENERAL": "Wrong data",

    //page scholarship
    "SCHOLARSHIP__ADD": "Add Scholarship",
    "SCHOLARSHIP__NAME_TH": "ชื่อทุนการศึกษา ภาษาไทย",
    "SCHOLARSHIP__NAME_EN": "ชื่อทุนการศึกษา ภาษาอังกฤษ",
    "SCHOLARSHIP__TYPE_OF_FUNDING": "ประเภทแหล่งทุน",
    "SCHOLARSHIP__NAME_OF_FUNDING": "ชื่อแหล่งทุน",
    "SCHOLARSHIP__ERP_CODE_FUNDING": "กำหนดการจัดสรร (ERP_CODE)",
    "SCHOLARSHIP__TYPE": "ประเภท",
    "SCHOLARSHIP__CLEMENT": "ทำผ่อนผัน",
    "SCHOLARSHIP__CAN_CHOOSE": "ผู้รับทุนเลือกเองได้",
    "SCHOLARSHIP__IMPRESSION": "แสดงในใบเสร็จรับเงิน",//"การแสดงผล",
    "SCHOLARSHIP__IMPRESSION_OPDC": "การแสดงผลรายงาน กพร.",
    "SCHOLARSHIP__PAYBACK_SCHOLARSHIP": "ทุนที่ต้องใช้คืน",
    "SCHOLARSHIP__ONLY_ONE_SCHOLARSHIP": "รับได้แค่ทุนนี้ทุนเดียว",
    "SCHOLARSHIP__SCHOLARSHIP_DETAILS": "Scholarship Details",
    "SCHOLARSHIP__SCHOLARSHIP_CODE": "Scholarship Code",
    "SCHOLARSHIP__ADD_DETAILS_HEADER": "Add Scholarship/Discount Details",
    "SCHOLARSHIP__AMOUNT_DISCOUNT": "Amount Discount",
    "SCHOLARSHIP__PERCENT_DISCOUNT": "Discount %",
    "SCHOLARSHIP__TYPE_OF_SCHOLARSHIP": "Type of Scholarships",
    "SCHOLARSHIP__DETAILS_OF_SCHOLARSHIP": "รายละเอียดของทุน",
    "SCHOLARSHIP__FUNDRAISING": "การให้ทุน",
    "SCHOLARSHIP__LIST_OF_FUNDERS": "Import รายชื่อผู้ได้รับทุน",
    "SCHOLARSHIP__FUNDRAISING_DETAILS": "รายละเอียดการให้ทุน",
    "SCHOLARSHIP__ADD_FUNDRAISING_DETAILS": "เพิ่ม รายละเอียดการให้ทุนการศึกษา",
    "SCHOLARSHIP__DETAIL": "Scholarship Details",
    "SCHOLARSHIP__DELETE_DATA_SUCCESS": "Successfully deleted Scholarship details",
    "SCHOLARSHIP__EDIT_DETAILS_HEADER": "Edit Scholarship/Discount Details",
    "SCHOLARSHIP__ADD_DETAIL_SUCCESS": "เพิ่มรายละเอียดทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__EDIT_DETAIL_SUCCESS": "แก้ไขรายละเอียดทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__SCHOLARSHIP": "ทุนการศึกษา",
    "SCHOLARSHIP__DELETE_SCHOLARSHIP_SUCCESS": "ลบทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__CF_SAVE_DATA": "รายละเอียดทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__SHOW_STUDENT_LIST": "รายชื่อผู้ได้รับทุน",
    "SCHOLARSHIP__IMPORT_BY_MAJOR": "นำเข้าข้อมูลการให้ทุน",
    "SCHOLARSHIP__SEARCH_STUDENT": "รหัส,ชื่อ ผู้รับทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__LIST_STD_FUNDERS": "รายชื่อนิสิตทั้งหมดที่ได้รับทุน",
    "SCHOLARSHIP__STUDENT": "นิสิตรหัส",
    "SCHOLARSHIP__DELETE_STUDENT_SUCCESS": "ลบนิสิตสำเร็จ",
    "SCHOLARSHIP__IMPORT_BY_EXCEL_CF": "ด้วยไฟล์ Excel",
    "SCHOLARSHIP__IMPORT_BY_MAJOR_CF": "รายกลุ่ม",
    "SCHOLARSHIP__ADD_BY_MAJOR": "เพิ่มข้อมูลการให้ทุนรายกลุ่ม/บุคคล สำเร็จ",
    "SCHOLARSHIP__IMPORT_BY_MAJOR_PERSON": "การให้ทุนรายกลุ่ม/บุคคล",
    "SCHOLARSHIP__TITLE_NAME": "ชื่อ, รหัสทุนการศึกษา",
    "SCHOLARSHIP__SEMESTER": "ภาคการศึกษาที่ได้รับทุน",
    "SCHOLARSHIP__ACADEMIC_YEAR": "ปีการศึกษาที่ได้รับทุน",
    "SCHOLARSHIP__STD_FUNDERS_CF": "รายชื่อนิสิตที่ได้รับทุน",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_CASE_2": "ไม่พบข้อมูลนิสิต หรือนิสิตไม่ตรงเงื่อนไขการรับทุน*",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_CASE_3": "นิสิตได้รับทุนการศึกษาในภาคการศึกษานี้แล้ว",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_CASE_4": "ไม่สามารถนำเข้านิสิตได้เนื่องจากมีการนำเข้าข้อมูลซ้ำ",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_DT": "*นิสิตที่สามารถรับทุนได้ ต้องมีสถานภาพนิสิตเป็น นิสิตปัจจุบัน, นิสิตใหม่, ลาพักการศึกษา และ ถูกลงโทษทางวินัยเท่านั้น",
    "SCHOLARSHIP__TAB_STD_TYPE_DATE": "กำหนดช่วงเวลาในการรับทุน",
    "SCHOLARSHIP__SCHOLARSHIP_PERIOD": "ช่วงเวลาในการรับทุน",
    "SCHOLARSHIP__SCHOLARSHIP_PERIOD_DELETED": "ลบช่วงเวลาในการรับทุนสำเร็จ",
    "SCHOLARSHIP__SCHOLARSHIP_PERIOD_ADD": "เพิ่มช่วงเวลาในการรับทุนสำเร็จ",
    "SCHOLARSHIP__NAME": "Name of Scholarship/Discount",
    "SCHOLARSHIP__NO": "No.",
    "SCHOLARSHIP__TYPE_SPORT": "Scholarship category",
    "SCHOLARSHIP__CAN_WITHDRAW": "Can Withdraw",
    "SCHOLARSHIP__CAN_NOT_WITHDRAW": "Can't Withdraw",
    "SCHOLARSHIP__WITHDRAW_STATUS": "Check Withdrawal Status",
    "SCHOLARSHIP__CONFIRM_FUND_IMPORT": "Confirm student fund",
    "SCHOLARSHIP__CONFIRM_FUND_IMPORT_UPLOAD": "Import student confirmed fund",

    //page setdebt
    "SETDEBT__CREATE_DEBT_BUTTON": "Create debt",
    "SETDEBT__PLEASE_SEARCH_STUDENT": "Please search student",
    "SETDEBT__CREATE_DEBT_IMPORT_BUTTON": "Import debt",

    //page DogSinger
    "DOCSIGNER__TITLE": "Document signer",
    "DOCSIGNER__ADD_BT": "Add document singer",
    "DOCSIGNER__POSITION": "Position",
    "DOCSIGNER__POSITION_TH": "Position (ไทย)",
    "DOCSIGNER__POSITION_EN": "Position (Eng)",
    "DOCSIGNER__NAME_PREFIX": "Name Prefix",
    "DOCSIGNER__NAME_Th": "Name (Thai)",
    "DOCSIGNER__NAME_En": "Name (Eng)",
    "DOCSIGNER__MIDNAME_TH": "Midlename (Thai)",
    "DOCSIGNER__MIDNAME_EN": "Midlename (Eng)",
    "DOCSIGNER__LASTNAME_Th": "Last name (ไทย)",
    "DOCSIGNER__LASTNAME_En": "Last name (Eng)",
    "DOCSIGNER__DOC_TYPE": "Document type",
    "DOCSIGNER__SIGNER_TYPE": "Types of signer",
    "DOCSIGNER__DIR_OF_TREASUARY": "Director of Treasury",
    "DOCSIGNER__FINANCIAL_OFFICER": "Financial officer",
    "DOCSIGNER__SIGNATURE_TH": "Thai signature",
    "DOCSIGNER__SIGNATURE_EN": "Eng signature",
    "DOCSIGNER__UPLOAD_SUGGEST": "Suggestion for upload file",
    "DOCSIGNER__UPLOAD_SUGGEST_DETAIL": "Only .jpg, .png formats to upload file and the image size less than 200 x 50 pixel.",
    "DOCSIGNER__MAIN_SIGNER": "Main signatory",
    "DOCSIGNER__REP_SIGNER": "Representative signatory",
    "DOCSIGNER__FILE_TOO_BIG": "Image file is too large",
    "DOCSIGNER__FILE_ONLY_IMG": "File must be an image file only.",
    "DOCSIGNER__FILE_TOO_WIDTH": "The image size must not exceed 200 x 50 pixel.",

    //page refund
    "REFUND__TITLE": "Refund",
    "REFUND__CREATE_REFUND": "Create refund",
    "REFUND__EDIT_REFUND": "Edit refund",
    "REFUND__LIST_NAME": "List name",
    "REFUND__REFUND_TYPE": "Refund type",
    "REFUND__MAX_AMT": "Maximum amount of refund",
    "REFUND__REFUND_DATE": "Date of refund",
    "REFUND__TO": "To",

    //payment page
    "PAYMENT__UNPAID_LIST": "Unpaid",
    "PAYMENT__PAID_LIST": "Paid",
    "PAYMENT__SCHOLARSHIP_LIST": "Scholarship",
    "PAYMENT__CURRENT_STUDENT_STATUS": "Student current status",
    "PAYMENT__WITHDRAWABLE_STATUS": "Withdrawable status",
    "PAYMENT__STUDENT_NAME": "Student Name, Student Code",
    "PAYMENT__FACT_NAME": "Payment", //การชำระเงินนิสิต
    "PAYMENT__INSTALLMENT_TYPE": "Installment type",
    "PAYMENT__DEBT_AMOUNT": "Debt amount",
    "PAYMENT__NET_AMOUNT": "Net amount",
    "PAYMENT__REFERENCE_NUMBER": "Reference number",
    "PAYMENT__PAY_VIA_BANK": "Pay via bank", //ชำระผ่านธนาคาร
    "PAYMENT__BANK_ACCOUNT": "Bank account no",
    "PAYMENT__WITHDRAW_AMOUNT": "Over Paid Refund", //ยอดจากบันชีรอถอนคืน
    "PAYMENT__BY_CASH": "Cash", //ชำระด้วยเงินสด
    "PAYMENT__PRINT_RECEIPT_TYPE": "Please select print type", //เลือกประเภทการพิมพ์ใบเสร็จ
    "PAYMENT__CAUSE_CANCEL": "Cause of cancel",
    "PAYMENT__FEE_DETAIL": "Fee list",
    "PAYMENT__STUDENT_DETAIL": "Student detail",
    "PAYMENT__FISCAL_YEAR": "Fiscal year",
    "PAYMENT__NUMBER_PRINT": "Number of prints",
    "PAYMENT__CREDIT": "Credit payment", //ค่าหน่วยกิจ
    "PAYMENT__FACULTY": "Faculty payment",
    "PAYMENT__FEE_UNIVERSITY": "Fee university",
    "PAYMENT__TIME_STUDENT": "Student time",//เวลาในการจัดการเรียนการสอน
    "PAYMENT__CANCEL_RECEIPT": "Cancel receipt",
    "PAYMENT__CANCEL_INVOICE": "Cancel invoice",
    "PAYMENT__CANCEL_RECEIPT_LIST": "Cancle recipts list",
    "PAYMENT__CANCEL_INVOICE_LIST": "Cancle invoices list",
    "PAYMENT__CONFIRM_CANCEL_RECEIPT": "Want to cancle a receipts list?",
    "PAYMENT__CONFIRM_CANCEL_INVOICE": "Want to cancle a Invoices list?",
    "PAYMENT__RECEIPT_ID": "Receipt No.",
    "PAYMENT__INVOICE_ID": "Invoice No.",
    "PAYMENT__DISCOUNT_AMT": "Discount amount",
    "PAYMENT__IMPORT_DATA_SAVED": "Import data saved",
    "PAYMENT__DOWNLOAD_ERR1": "Cannot download invoice(no invoice no.)",
    "PAYMENT__DOWNLOAD_ERR2": "Cannot download receipt(no receipt no.)",
    "PAYMENT__CREDITBALANCE_TYPE": "Creditbalance type",
    "PAYMENT__CREDITBALANCE_TYPE_OVERIDE": "Overide payment type",
    "PAYMENT__BY_CREDITBALANCE": "Creditbalance",

    //page erp
    "ERP__CODE": "Organizational dimension code",
    "ERP__CODE_NAME": "Organizational dimension name",
    "ERP__CODE_NAME_TH": "Organizational dimension name (Th)",
    "ERP__CODE_NAME_EN": "Organizational dimension name (En)",
    "ERP__DETAIL": "Organizational dimension",
    "ERP__PROJECT_CODE": "Project Code",
    "ERP__ADD_SUCCESS": "Add Organizational dimension success",
    "ERP__Force_Stucture": "Force structure", //ไม่แน่ใจ
    "ERP__SAVE_DUPLICATED_TITLE": "Cannot create new erp",
    "ERP__SAVE_DUPLICATED_DESCRIPTION": "The inputs data is same as other erp, please make some change",
    "ERP__Special_Project_Flag" : "Is special project ?",

    //page fine
    "FINE__PAGE_TITLE": "Fines from external agencies",
    "FINE__TITLE_IMPORT": "Import a list of fines from external agencies",
    "FINE__ORG": "Agency",
    "FINE__STUDENT_NOT_FOUND": "Student data not found",
    "FINE__STUDENT_DUP": "student has already imported this semester",//unsure
    "FINE__SEARCH_STUDENT": "Student id, name of students who import fines from external agencies",
    "FINE__FINE": "Fine",
    "FINE__RETURN_BOOK": "Pending book",
    "FINE__RETURN_SPORT_EQUIP": "Pending sports equipment",
    "FINE__STATUS": "Status",
    "FINE__CAUTION": "Caution:",


    //page specialSubject
    "SPECIALSUBJECT__FEE_TITLE_SPECIAL": "Special subject fee management",
    "SPECIALSUBJECT__FEE_NAME": "Fee name",
    "SPECIALSUBJECT__SEMESTER_YEAR": "Semester / Academic Year",
    "SPECIALSUBJECT__RESULT": "Result",
    "SPECIALSUBJECT__DELETE_SUCCESS": "Deleted Success",
    "SPECIALSUBJECT__ADD_FEE_TITLE_SPECIAL": "Add special subject fee management",
    "SPECIALSUBJECT__TYPE_TRANSACTION": "Type transaction",
    "SPECIALSUBJECT__SUBJECT_CODE_NAME": "Code/Name subject",
    "SPECIALSUBJECT__SUBJECT_NAME": "Name subject",
    "SPECIALSUBJECT__SUBJECTS": "Subjects set",
    "SPECIALSUBJECT__PAY_UNIVERSITY": "University rate", //อัตราค่าบำรุงมหาลัย
    "SPECIALSUBJECT__PAY_FACULTY": "Faculty rate",
    "SPECIALSUBJECT__PAY_CREDIT": "Credit rate",
    "SPECIALSUBJECT__PAY_TYPE" : "Type of payment",
    "SPECIALSUBJECT__LECTURE_PAY_CREDIT": "Lec credit price(baht)", //ราคาหน่วยกิตบรรยาย
    "SPECIALSUBJECT__LAB_PAY_CREDIT": "Lab credit price(baht)", //ราคาหน่วยกิตปฏิบัติ
    "SPECIALSUBJECT__SET_RATE": "Set rate",
    "SPECIALSUBJECT__TOTAL_UNIVERSITY_RATE": "Total university rate",
    "SPECIALSUBJECT__TOTAL_FACULTY_RATE": "Total faculty rate",
    "SPECIALSUBJECT__TOTAL_CREDIT_RATE": "Total credit rate",
    "SPECIALSUBJECT__SPECIAL_FEE_SUCCESS": "Add special fee success",
    "SPECIALSUBJECT__ADD_SUBJECTS_SUCCESS": "Add subjects success",
    "SPECIALSUBJECT__ADD_SET_SUCCESS": "Add subjects set success",
    "SPECIALSUBJECT__DELETE_SUBJECTS_SUCCESS": "Deleted subjects Success",
    "SPECIALSUBJECT__DELETE_SET_SUCCESS": "Deleted subjects set success",
    "SPECIALSUBJECT__BOOK_COST": "Books cost(baht)",
    "SPECIALSUBJECT__ADD_STUDENT_TO_SS": "Add students to subject",
    "SPECIALSUBJECT__BY_UNIT": "By credit",
    "SPECIALSUBJECT__BY_SUBJECT": "By subject",

    //page SubjectBundle
    "SUBJECTSBUNDLE__SUBJECTS_TYPE": "Type subjects set",
    "SUBJECTSBUNDLE__NAME_AND_CODE": "Name and subjects code",
    "SUBJECTSBUNDLE__SUBJECTS_NAME_TH": "Subjects name (Th)",
    "SUBJECTSBUNDLE__SUBJECTS_NAME_EN": "Subjects name (En)",
    "SUBJECTSBUNDLE__ADD_SUBJECTS_SUCCESS": "Add type subjects set success",
    "SUBJECTSBUNDLE__ADD_DATA_COURSE_SUCCESS": "Add course data success",
    "SUBJECTSBUNDLE__DELETE_COURSE_SUCCESS": "Deleted course success",

    //page E-Student Loan
    "UNIVERSITY_LOAN__FUND_TYPE": "Fund Type",

    //Message Error ps. NFMSG = New FIN Message
    "NFMSG__SAVE_DATA_ERROR": "An error occurred while saving data",
    "NFMSG__LOAD_DATA_ERROR": "An error occurred while loading data", //ใช้สำหรับ else error ตัวสุดท้าย
    "NFMSG__PLZ_TRY_AGAIN": "Please try again.",
    "NFMSG__CANNOT_BE_SAVE": "The record could not be saved",
    "NFMSG__CAUSE": "because,",
    "NFMSG__DUP_SCHOLARSHIP_SEQ": "there is already this Number in the system.",
    "NFMSG__ALREADY_HAVE_IN_CAMPUS": "The scholarship details for this campus, semester and academic year are recorded in the system.",

    //payment detail
    "FNSTD__PAYMENT_DATE": "Payment date",
    "FNSTD__RECEIPT_DETAILS": "Receipt detail",
    "FNSTD__PRINT_RECEIPT": "Print receipt",
    "FNSTD__PRINT_INVOICE": "Print invoice",
    "FNSTD__CHOOSE_RECEIPT": "Please choose a receipt type",
    "FNSTD__MASTER_RECEIPT": "Master receipt",
    "FNSTD__COPY_RECEIPT": "Copy receipt",

    //allocation
    "ALLO__CONFIG_TITLE": "Allocation configure",
    "ALLO__ALLO_NAME_TH": "Thai allocation name",
    "ALLO__ALLO_NAME_EN": "English allocation name",
    "ALLO__CONFIGURE_PAGE_TITLE": "Allocation date setup",

    "USR_LOAD_CONFIG_ERROR": "Cannot load config data",

    "COMMON__NUMBER_OF_STUDENTS": "Number of Student(s)",

    "ALERT__FAILED_TO_SAVE_DATA": "Failed to save data",
    "ALERT__FAILED_COMMON_DESC": "Please try again later, if problem persist please contact administrator",
    "CLS_EXAM__DATA_NOT_FOUND": "No subject. please select subject from search box",

    "LNF_NO_STUDENTS": "There are no students",
    "EXAM_EXAMINER_LABEL" : "Examiner name",
    "EXAM_STUDENT_REGISTER" : "Registered students",
    "EXAM_STUDENT_COUNT" : "Student count",

    "COMMON__DATE": "Date",
    "COMMON__START_TIME": "Start time",
    "COMMON__END_TIME": "End time",
}
